<template>
  <b-modal
    :visible="show"
    @hidden="hideEvents"
    title="Update Extended Due Dates"
    :id="modalId"
    size="lg"
  >
    <vue-element-loading :active="loading" :is-full-screen="false"/>

    <div class="py-3">
      <p class="mb-4 text-muted">
        Choose how to update the extended due date for the {{ nodeIds.length }} selected action{{ nodeIds.length !== 1 ? 's' : '' }}.
      </p>

      <div class="border rounded p-3 bg-light">
        <div class="mb-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="extendedDueDateOption"
              id="setExtendedDateOption"
              value="setDates"
              v-model="selectedOption"
              :disabled="loading"
            >
            <label class="form-check-label font-weight-medium" for="setExtendedDateOption">
              Set a new date
            </label>
          </div>

          <div v-if="selectedOption === 'setDates'" class="ml-4 mt-3">
            <b-form-group label="New Extended Due Date" label-size="sm">
              <input
                type="date"
                v-model="value"
                class="form-control"
                :disabled="loading"
              >
            </b-form-group>
          </div>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="extendedDueDateOption"
            id="clearExtendedDateOption"
            value="clearDates"
            v-model="selectedOption"
            :disabled="loading"
          >
          <label class="form-check-label font-weight-medium" for="clearExtendedDateOption">
            Clear existing extended due dates
          </label>
        </div>
      </div>

      <div class="mt-3 p-3 bg-info text-dark rounded">
        <h6 class="mb-1 font-weight-bold">Important Note</h6>
        <small>This change will replace any existing extended due dates for the selected actions.</small>
      </div>
    </div>

    <template slot="modal-footer">
      <b-button
        variant="outline-secondary"
        @click="hideModal"
        :disabled="loading">
        Cancel
        <font-awesome-icon
          :icon="['far', 'times']">
        </font-awesome-icon>
      </b-button>
      <b-button
        class="btn-arrow"
        variant="primary"
        @click="bulkEditExtendedDueDate"
        :disabled="isButtonDisabled"
      >
        <span v-if="!loading">Update Extended Due Dates</span>
        <span v-else>Updating...</span>
        <font-awesome-icon
          v-if="!loading"
          :icon="['far', 'arrow-right']">
        </font-awesome-icon>
        <font-awesome-icon
          v-else
          :icon="['fal', 'spinner']"
          spin>
        </font-awesome-icon>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin'
import Action from "@/services/Action/Action";

export default {
  name: 'BulkEditExtendedDueDateModal',
  props: {
    nodeIds: {
      type: Array,
      default: () => [],
    },
    actionCount: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      required: true,
    },
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'extendedDueDateModal',
      loading: false,
      value: '',
      selectedOption: null,
    };
  },
  computed: {
    isButtonDisabled() {
      if (this.loading) return true;
      if (!this.selectedOption) return true;
      return this.selectedOption === 'setDates' && !this.value;
    },
  },
  methods: {
    async bulkEditExtendedDueDate() {
      if (this.nodeIds.length === 0) {
        return;
      }

      this.loading = true;

      const dueDateValue = this.selectedOption === 'setDates' ? this.value : null;

      await Action.bulkUpdateExtendedDueDate(this.nodeIds, dueDateValue)
        .then((response) => {
          const updated = response.data.updatedCount;

          const text = this.selectedOption === 'clearDates'
            ? `Extended due dates cleared for ${updated} action${updated !== 1 ? 's' : ''}.`
            : `Extended due date updated for ${updated} action${updated !== 1 ? 's' : ''}.`;

          this.$notify({
            title: 'Success',
            text,
            type: 'success',
          });
        })
        .catch((e) => {
          this.$notify({
            title: 'Error',
            text: 'Something went wrong. Please try again.',
            type: 'error',
          });
        });
      this.$store.dispatch('refreshActions');
      this.hideModal();
    },

    hideModalEvents() {
      this.value = '';
      this.selectedOption = null;
    },
  },
};
</script>

<style lang="scss">
.modal {
  .btn.btn-arrow {
    min-width: 140px;
  }

  .btn-outline-secondary + .btn-arrow {
    margin: auto;
    margin-right: 0;
  }
}
</style>
